import styled from "styled-components"

import { SPACING } from "../../component-library/design/spacing/spacing.constants"
import { CreditCardGroup } from "../../billing/components/credit-card-group.component"
import {
  StyledAddCardButton,
  PaymentWrapper,
} from "../../billing/components/credit-card-group.component.styles"

const StyledCreditCardGroup = styled(CreditCardGroup)`
  ${StyledAddCardButton} {
    margin-top: ${SPACING.XS};
    margin-left: 0;
  }
  ${PaymentWrapper} {
    flex-direction: column;
  }
`

const ReadOnlyCreditCardContainer = styled.div`
  opacity: 0.38;
  padding: 0 32px;
`

export { StyledCreditCardGroup, ReadOnlyCreditCardContainer }
